module.exports = __webpack_public_path__ + "static/Coinegg-728d5db6c9757da35af9aa81d86d1a0e.png";